import { Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";

export const CustomWrapper = styled(Center)`
    width: 100%;
    flex-direction: column;
    box-sizing: border-box;
    gap: 24px;
`;

export const CustomTitle = styled(Text)`
    ${FONT("pretendard", 24, 700)};
`;
